import { Box } from "@mui/material"

// Shared "Comments" tab label with a leading unread-count pill, used by both the recipient and the
// internal (sharer) Comments tabs. With nothing unread the label is the plain "Comments" string.
export function CommentsTabUnreadLabel({ total = 0 }) {
    if (!total) return "Comments"

    return (
        <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
            <Box
                component="span"
                data-cy="share-comments-unread-count"
                sx={{
                    height: 18,
                    px: 0.75,
                    borderRadius: 999,
                    bgcolor: "primary.lighter",
                    color: "primary.darker",
                    fontSize: 11,
                    fontWeight: 700,
                    lineHeight: "18px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                }}
            >
                {total} unread
            </Box>
            Comments
        </Box>
    )
}
